import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { useRevealAll } from './landing/useReveal'
import { LandingNav } from './landing/LandingNav'
import { HeroSection } from './landing/HeroSection'
import { SocialProofBar } from './landing/SocialProofBar'
import { ProblemSection } from './landing/ProblemSection'
import { FeaturesSection } from './landing/FeaturesSection'
import { HowItWorksSection } from './landing/HowItWorksSection'
import { TestimonialsSection } from './landing/TestimonialsSection'
import { PricingSection } from './landing/PricingSection'
import { FAQSection } from './landing/FAQSection'
import { FinalCTASection } from './landing/FinalCTASection'
import { LandingFooter } from './landing/LandingFooter'

export const LandingPage = () => {
  const session  = useAuthStore((s) => s.session)
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    if (session) navigate('/home', { replace: true })
  }, [session, navigate])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useRevealAll()

  return (
    <div className="min-h-screen bg-background text-text-primary">
      <LandingNav scrolled={scrolled} />
      <HeroSection />
      <SocialProofBar />
      <ProblemSection />
      <FeaturesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <FinalCTASection />
      <LandingFooter />
    </div>
  )
}
